import { extend } from 'sk-ui/lib/utils/util.js'

import sceneDirForm from './metaData/sceneDirForm'

export default {
  SceneDirCreate({ commit }, params) {
    const props = {
      extraParams: {
        industryId: params.viewController?.viewMetaData?.params?.industryId
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: sceneDirForm,
      props
    })
  },
  SceneDirEdit({ commit }, params) {
    const props = {
      title: '编辑场景目录',
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        industryId: params.viewController?.viewMetaData?.params?.industryId
      }
    }
    const editForm = extend(true, {}, sceneDirForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
